<template>
  <div>
    <FormRow class="designation" inline>

      <FormSelect
        field="custom.designation"
      >
        <option value="">Select Region</option>
        <option value="NCSY_Alumni">Alumni</option>
        <option value="NCSY_Argentina">Argentina</option>
        <option value="NCSY_Atlanta_JSU">Atlanta JSU</option>
        <option value="NCSY_Atlanta">Atlanta NCSY</option>
        <option value="NCSY_AtlanticSeaboard">Atlantic Seaboard</option>
        <option value="NCSY_Boston">Boston</option>
        <option value="NCSY_Canada">Canada</option>
        <option value="NCSY_CentralEast">Central East</option>
        <option value="NCSY_Chile">Chile</option>
        <option value="NCSY">General NCSY</option>
        <option value="NCSY_Israel">Israel</option>
        <option value="NCSY_Mexico">Mexico</option>
        <option value="NCSY_Midwest">Midwest</option>
        <option value="NCSY_Portland">Portland</option>
        <option value="NCSY_Southern">Southern</option>
        <option value="NCSY_Southwest">Southwest</option>
        <option value="NCSY_STL">St. Louis</option>
        <option value="NCSY_Summer">Summer</option>
        <option value="NCSY_Tristate">Tristate</option>
        <option value="NCSY_WestCoast">West Coast</option>
      </FormSelect>

      <!-- <FormSelect field="custom.subDesignation" v-if="getValue('custom.designation') == 'NCSY_CentralEast' || getValue('custom.designation') == 'NCSY_Midwest'  || getValue('custom.designation') == 'NCSY_Southern'  || getValue('custom.designation') == 'NCSY_Tristate'  || getValue('custom.designation') == 'NCSY_WestCoast'">
    <option value="">Select Option</option>
    <option value="4G">4G</option>

    </FormSelect> -->
    </FormRow>
  </div>
</template>
<script lang="ts">
import { defineComponent, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { form, getValue, settings, setValue } = usePaymentForm();

    return {
      getValue,
      form,
    };
  },
});
</script>
<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
.hidden {
  display: none !important;
}
</style>
